import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Box, Modal, TextField, Typography, Link } from "@mui/material";

import "../login.scss";
import styles from "../login.style";
import useSupportHelper from "./helper";
import { IMAGES } from "../../../common/constants";
import Schema from "../../../common/constants/schema";
import Input from "../../../components/formControls/input";
import ContainedButton from "../../../components/button/contained-button";
import SelectComp from "../../../components/formControls/select/singleSelect";

export default function Support() {
  const {
    open,
    cmsLinks,
    initialValues,
    supportReasonOptions,

    handleClose,
    onSubmitHandler,
    handleModalClose,
    handleSupportBackBtnClick,
  } = useSupportHelper();

  return (
    <div className="login-container support">
      <div>
        <Box sx={styles.backtologin}>
          <ContainedButton
            title=""
            className="backtologin"
            externalStyles={styles.btnback}
            fullWidth
            size="large"
            type="submit"
            onClick={handleSupportBackBtnClick}
          />
        </Box>

        <h1 className="email-verification">Support</h1>
        {/* <h3 className="code">
          Support request will be sent to
          <span>{supportDynamicEmail || "support.databis@yopmail.com"}</span>
        </h3> */}
        <Formik
          onSubmit={onSubmitHandler}
          initialValues={initialValues}
          validationSchema={Schema.SupportSchema}
        >
          {(props) => (
            <Form>
              <Box sx={styles.boxcontainer}>
                <Input
                  isRequired
                  label="Email"
                  id="email"
                  name="email"
                  placeholder="Enter Email"
                  className="customInput"
                />
              </Box>

              <Box sx={styles.boxcontainer}>
                <Input
                  isRequired
                  name="name"
                  label="Name"
                  className="customInput"
                  placeholder="Enter Name"
                />
              </Box>

              <Box sx={styles.boxcontainer}>
                <Input
                  isRequired
                  label="Subject"
                  id="subject"
                  name="subject"
                  className="customInput"
                  placeholder="Enter Subject"
                />
              </Box>

              <Box sx={styles.boxcontainer}>
                <SelectComp
                  isRequired
                  valKey="value"
                  labelKey="label"
                  name="supportReason"
                  label="Support Reason"
                  placeholder="Select Reason"
                  options={supportReasonOptions}
                />
              </Box>

              <Box sx={styles.boxcontainer}>
                <Typography variant="h6" component="label" sx={styles.label}>
                  Support Message<sup>*</sup>
                </Typography>
                <Field
                  as={TextField}
                  id="supportMessage"
                  name="supportMessage"
                  variant="outlined"
                  placeholder="Type your message here..."
                  multiline
                  rows={6}
                  fullWidth
                  error={
                    props.touched.supportMessage &&
                    Boolean(props.errors.supportMessage)
                  }
                  helperText={<ErrorMessage name="supportMessage" />}
                  sx={styles.authInput}
                />
              </Box>

              <Box sx={styles.btnContainer}>
                <ContainedButton
                  title="Send Request"
                  externalStyles={styles.btn}
                  fullWidth
                  size="large"
                  type="submit"
                  disabled={
                    props.isSubmitting || !props.isValid || !props.dirty
                  }
                />
              </Box>
              {/* <Box sx={styles.btnwrapper}>
                <Typography component="a" onClick={handleBackToLoginClick}>
                  Back to Login
                </Typography>
              </Box> */}
              <Box>
                <div className="cms-link-wrapper">
                  <span className="cms-text">
                    By clicking Send Request, you agree to our&nbsp;
                    <Link
                      href={cmsLinks?.terms_of_use}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="link"
                    >
                      Terms of Use
                    </Link>
                    &nbsp;and&nbsp;
                    <Link
                      href={cmsLinks?.privacy_policy}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="link"
                    >
                      Privacy Policy
                    </Link>
                  </span>
                  <div className="links privacyChoice">
                    <img
                      src={IMAGES.PrivacyChoiceIcon}
                      alt="Privacy Choice Icon"
                      className="privacyIcon"
                    />
                    <Link
                      href={cmsLinks?.your_privacy_choices}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="link"
                    >
                      Your Privacy Choices
                    </Link>
                  </div>
                </div>
              </Box>
            </Form>
          )}
        </Formik>
        <Modal
          open={open}
          aria-labelledby="unstyled-modal-title"
          aria-describedby="unstyled-modal-description"
          onClose={(event: {}, reason: "backdropClick" | "escapeKeyDown") => {
            if (reason !== "backdropClick") handleClose();
          }}
          slotProps={{
            backdrop: {
              sx: { backdropFilter: "blur(10px)" }, // Apply blur effect
            },
          }}
        >
          <Box className="success-popup" sx={{ width: 400 }}>
            <div className="popup-wrap">
              <img src={IMAGES.Tick} alt=".." />
              <h2 className="modal-title">Submitted!</h2>
              <p className="modal-description">
                Your Support request has been raised to the Databis Admin. You
                will soon receive the update on your registered Email.
              </p>
              <button type="button" className="" onClick={handleModalClose}>
                Okay
              </button>
            </div>
          </Box>
        </Modal>
      </div>
    </div>
  );
}
